
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { BookingFormData } from "../ParcelBookingForm";
import { ArrowLeftRight, Shield } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Separator } from "@/components/ui/separator";
import MultiContactSection from "../contact-form/MultiContactSection";
import { useMultiContactForm } from "../contact-form/useMultiContactForm";
import { LegalContentDialog } from "@/components/legal/LegalContentDialog";

interface ContactStepProps {
  formData: BookingFormData;
  setFormData: React.Dispatch<React.SetStateAction<BookingFormData>>;
  onValidationChange: (isValid: boolean) => void;
}

const ContactStep = ({
  formData,
  setFormData,
  onValidationChange
}: ContactStepProps) => {
  const isMobile = useIsMobile();
  const [showLegalDialog, setShowLegalDialog] = useState(false);
  const {
    handleCollectionContactsChange,
    handleDeliveryContactsChange,
    handleSwapContacts,
    isContactsValid
  } = useMultiContactForm(formData, setFormData, onValidationChange);

  return (
    <div className="space-y-6">
      <div className="flex justify-end">
        <Button variant="outline" size="sm" onClick={handleSwapContacts} className="mb-2 w-full">
          <ArrowLeftRight className="h-4 w-4 mr-2" />
          {isMobile ? "Swap" : "Swap Contacts"}
        </Button>
      </div>

      <MultiContactSection
        title="Collection Contacts"
        contacts={formData.collectionContacts}
        onContactsChange={handleCollectionContactsChange}
        prefix="collection"
      />

      <Separator className="my-4" />

      <MultiContactSection
        title="Delivery Contacts"
        contacts={formData.deliveryContacts}
        onContactsChange={handleDeliveryContactsChange}
        prefix="delivery"
      />

      {/* Privacy Policy Footer */}
      <div className="flex items-center justify-center gap-2 pt-2 text-center">
        <Shield className="h-4 w-4 text-muted-foreground" />
        <button 
          type="button"
          onClick={() => setShowLegalDialog(true)}
          className="text-sm text-muted-foreground hover:text-primary hover:underline transition-colors"
        >
          Review our Privacy Policy for details on protection of personal information.
        </button>
      </div>

      {/* Legal Content Dialog */}
      <LegalContentDialog 
        open={showLegalDialog} 
        onOpenChange={setShowLegalDialog}
        initialTab="privacy"
      />
    </div>
  );
};

export default ContactStep;
